<template>
  <div ref="container">
    <a-modal :title="title" width="98%" :visible="visible" :confirmLoading="confirmLoading"
             :getContainer="() => $refs.container" :maskStyle="{'top':'23px','left':'154px'}"
             :wrapClassName="wrapClassNameInfo()" :mask="isDesktop()" :maskClosable="false"
             @ok="handleOk" @cancel="handleCancel" cancelText="关闭" style="top:3%;height: 90%;">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">
          关闭
        </a-button>
        <a-button type="primary" @click="handleOk">
          确认
        </a-button>
      </template>
      <a-spin :spinning="confirmLoading">
        <div class="productInfo">
          <a-form-model ref="form" :model="form" :rules="rules">
            <a-row class="form-row">
              <a-col :span="11">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="运单编号" prop="waybillNumber">
                  <a-input placeholder="请输入运单编号" v-model="form.waybillNumber" />
                </a-form-model-item>
              </a-col>
              <a-col :span="11">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="关联销售出库单" prop="salesOutboundOrder">
                  <a-input-search placeholder="请选择关联销售出库单" @change="xiaoshouchuku" v-model="form.salesOutboundOrder" @search="onSearchLinkNumber" :readOnly="true" />
                </a-form-model-item>
              </a-col>
              <a-col :span="11">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="承运公司" prop="carrierName">
                  <a-select v-model="form.carrierName" placeholder="请选择承运公司" @change="getinfo(true)">
                    <a-select-option v-for="(item,index) in carrierName" :value="item.companyName">{{item.companyName}}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="11">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="承运联系人" prop="carrierName">
                  <a-select v-if="bianji" v-model="form.contactName" placeholder="请选择联系人" @change="x" style="width: calc( 100% - 90px );margin-right: 10px">
                    <a-select-option v-for="(item,index) in lianxiren" :value="item.carrierName">{{item.carrierName}}</a-select-option>
                  </a-select>
                  <a-input v-else v-model="form.contactName" placeholder="请选择联系人" style="width: calc( 100% - 90px );margin-right: 10px"></a-input>
                  <a-button @click="bianji = !bianji" style="float: right;margin-top: 4px" type="primary" > {{bianji?'编辑':'选择'}} </a-button>
                </a-form-model-item>
              </a-col>
              <a-col :span="11">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="承运人联系电话" prop="contactPhone">
                  <a-input placeholder="请输入联系电话" v-model="form.contactPhone" />
                </a-form-model-item>
              </a-col>
              <a-col :span="11">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="结算方式"
                                   prop="settlementMethod" placeholder="请选择结算方式">
                  <a-select v-model="form.settlementMethod">
                    <a-select-option value="0">月结</a-select-option>
                    <a-select-option value="1">寄付现结</a-select-option>
                    <a-select-option value="2">到付</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>

              <a-col :span="11">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="客户" prop="customerName">
                  {{form.customerName}}
                </a-form-model-item>
              </a-col>

              <a-col :span="11">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="费用" prop="fee">
                  <a-input placeholder="请输入费用" v-model="form.fee" />
                </a-form-model-item>
              </a-col>

              <a-col :span="22">
                <a-form-model-item :labelCol="{
                    xs: { span: 12 },
                    sm: { span: 4 }
                  }" :wrapperCol="wrapperCol" label="收件地址" prop="recipientAddressDetail">
                  <a-select v-model="form.recipientAddressDetail" placeholder="请输入收件地址">
                    <a-select-option v-for="(item,index) in peopleAddress" :value="item.customerAddressId+''">{{item.areaAddress}},{{item.detailAddress}}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>

              <a-col :span="11">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="收件人" prop="recipientName">
                  <a-input placeholder="请输入收件人" v-model="form.recipientName" />
                </a-form-model-item>
              </a-col>

              <a-col :span="11">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="收件人联系电话" prop="recipientPhone">
                  <a-input placeholder="请输入联系电话" v-model="form.recipientPhone" />
                </a-form-model-item>
              </a-col>
              <a-col :span="22">
                <a-form-model-item :labelCol="{
                    xs: { span: 12 },
                    sm: { span: 4 }
                  }" :wrapperCol="wrapperCol" label="发件地址" prop="senderAddressDetail">
                  <a-input placeholder="请输入发件地址" v-model="form.senderAddressDetail" />
                </a-form-model-item>
              </a-col>
              <a-col :span="11">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="发件人" prop="senderName">
                  <a-input placeholder="请输入发件人" v-model="form.senderName" />
                </a-form-model-item>
              </a-col>
              <a-col :span="11">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="发件人联系电话" prop="senderPhone">
                  <a-input placeholder="请输入联系电话" v-model="form.senderPhone" />
                </a-form-model-item>
              </a-col>

              <a-col :span="11">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注" prop="remark">
                  <a-textarea v-model="form.remark" placeholder="备注"></a-textarea>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
        </div>

      </a-spin>
    </a-modal>
    <link-bill-list2 ref="linkBillList" @ok="linkBillListOk"></link-bill-list2>
  </div>
</template>
<script>
import JImageUpload from '@/components/jeecg/JImageUpload'
import {
  addresslist,
  carrierManagementqueryCarrierCompany,
  checkSupplier,
  getCarrierUserByCarrierId,
  queryCustomerByOutOrderNumber,
  waybillManagementadd,
  waybillManagementedit,
  waybillManagementgetCompanyInfo,
  waybillManagementqueryById,
  waybillqueryOutOrderNumbers
} from '@/api/api'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import Vue from 'vue'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import JAreaLinkage from '@comp/jeecg/JAreaLinkage.vue'
import LinkBillList2 from '@views/bill/dialog/LinkBillList2.vue'
import { FormTypes } from '@/utils/JEditableTableUtil'

export default {
  name: 'VendorModal',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    LinkBillList2,
    JAreaLinkage,
    JImageUpload
  },
  // props:['productType'],
  props: {
    productType: Number
  },
  data () {
    return {
      bianji:true,
      lianxiren:[],
      salesOutboundOrder:[],
      carrierName:[],
      peopleAddress:[],
      List: [],
      headers: {
        'X-Access-Token': Vue.ls.get(ACCESS_TOKEN),
        tenantId: this.$store.getters.tenantId,
        createBy: this.$store.getters.userInfo.loginName
      },
      title: '操作',
      visible: false,
      fileList: [],
      model: {},
      companyId: '',
      isReadOnly: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      chengYunRenList: [
        {
          carrierName: '',
          carrierPhone: '',
          isDefault: 1
        }
      ],
      form: {
        salesOutboundOrder: ''
      },
      uploadHeaders: {},
      action: window._CONFIG['domianURL'] + '/systemConfig/upload',
      rules: {
        waybillNumber: [{ required: true, message: '请输入运单编号' }],
        salesOutboundOrder: [{ required: true, message: '请输入销售出库单' }],
        companyAddressDetail: [{ required: true, message: '请输入公司地址详细地址' }],
        carrierName: [{ required: true, message: '请输入承运联系人' }],
        contactPhone: [{ required: true, message: '请输入承运联系电话' }],
        customerName: [{ required: true, message: '请输入客户' }],
        recipientAddressDetail: [{ required: true, message: '请输入收件地址' }],
        recipientName: [{ required: true, message: '请输入收件人' }],
        recipientPhone: [{ required: true, message: '请输入收件人联系电话' }],
        fee: [{ required: true, message: '请输入费用' }],
      },
      id: ''
    }
  },
  created () {
  },
  methods: {
    onSearchLinkNumber() {
      this.$refs.linkBillList.show(this.form.salesOutboundOrder,true)
      this.$refs.linkBillList.title = '选择销售订单'
    },
    linkBillListOk(rowlist) {

      this.$set(this.form,'salesOutboundOrder',rowlist[0].defaultNumber)
      this.xiaoshouchuku(true)
    },
    xiaoshouchuku(clear){
      if(clear){
        this.$set(this.form,'recipientAddressDetail','')
      }
      queryCustomerByOutOrderNumber({outOrderNumber:this.form.salesOutboundOrder}).then(res=>{
        this.$set(this.form,'customerName',res.result.customerName)
        this.$set(this.form,'customerId',res.result.customerId)
        this.$set(this.form,'recipientName',res.result.contacts)
        this.$set(this.form,'recipientPhone',res.result.phoneNum)
        this.peopleAddress = res.result.address
      })
    },
    x(c){
      let phone = this.lianxiren.find(x=>x.carrierName == c).carrierPhone
      console.log('==>',c,phone)
      this.$set(this.form,'contactPhone',phone)
    },
    getAddressList (code, name, value) {
      addresslist({
        parentCode: code
      }).then(res => {
        console.log(res.result)
        this.address[name] = res.result
        if (value) {
          if (Array.isArray(value)) {
            value.forEach(v => {
              this.address[v] = ''
              if (v == 'value3') {
                this.form.companyAddressAreaId = ''
              }
            })
          } else {
            this.address[value] = ''
            if (value == 'value3') {
              this.form.companyAddressAreaId = ''
            }
          }
        }
      })
    },


    async init(){
      let res = await waybillqueryOutOrderNumbers()
      this.salesOutboundOrder = res.result
      let res2 = await carrierManagementqueryCarrierCompany()
      this.carrierName = res2.result
    },
    getinfo(clear){
      if(clear){
        this.$set(this.form,'contactName','')
        this.$set(this.form,'contactPhone','')
      }
      const c = this.carrierName.find(x=>x.companyName == this.form.carrierName)
      this.$set(this.form,'settlementMethod',c.settlementMethod+'')
      getCarrierUserByCarrierId({carrierId:c.id}).then(res=>{
        this.lianxiren = res.result
      })
    },
    add () {
      this.form = {}
      this.init()
      waybillManagementgetCompanyInfo().then(res=>{
        this.$set(this.form,'senderAddressDetail',res.result.senderAreaName+','+res.result.senderAddressDetail)
        this.$set(this.form,'senderName',res.result.senderName)
        this.$set(this.form,'senderPhone',res.result.senderPhone)
      })
      this.visible = true
    },
    async edit (record) {
      const that = this
      that.getAddressList('100000', 'list1')
      let res = await waybillManagementqueryById({ id: record.id })
      record = res.result
      that.form = record
      await this.init()
      await this.getinfo()
      await this.xiaoshouchuku()
      this.visible = true
    },

    close () {
      this.$emit('close')
      this.visible = false
    },
    handleOk () {
      const that = this
      // 触发表单验证
      that.$refs['form'].validate(async (success) => {
        if (success === true) {
          this.form.carrierUsers = this.chengYunRenList
          if (this.form.id) {
            // 编辑
            const res = await waybillManagementedit(this.form)
            console.log(res, 'res')
            if (res.code == 200 && res.success == true) {
              this.$message.success(res.message)
              this.$emit('ok')
              this.close()
            } else {
              this.$message.error(res.data || res.errmsg)
            }
          } else {
            const res = await waybillManagementadd(this.form)
            if (res.code == 200 && res.success == true) {
              this.$message.success(res.message)
              this.$emit('ok')
              this.close()
            } else {
              this.$message.error(res.message)
            }
          }
        }
      })
    },
    handleCancel () {
      this.close()
    },
    validateSupplierName (rule, value, callback) {
      let params = {
        name: value,
        type: '供应商',
        id: this.model.id ? this.model.id : 0
      }
      checkSupplier(params).then((res) => {
        if (res && res.code === 200) {
          if (!res.data.status) {
            callback()
          } else {
            callback('名称已经存在')
          }
        } else {
          callback(res.data)
        }
      })
    }
  }
}
</script>
<style scoped>
.productInfo {
  padding: 10px;
}

.productInfo .title {
  font-size: 16px;
  border-left: 4px solid #1890FE;
  padding-left: 10px;
  margin: 0 10px;
}
</style>


